/* eslint-disable consistent-return */
var sizes = {
  small: 16,
  medium: 20,
  large: 24
};
var rotations = {
  up: 0,
  right: 90,
  down: 180,
  left: 270
};
var BASE_SIZE = 24;
var BASE_STROKE = 1.25;

var isValidUnit = function isValidUnit(val) {
  return typeof val === 'string' || typeof val === 'number';
};

export var getSizeValue = function getSizeValue(size) {
  var sizeNum = +size;
  return Number.isNaN(sizeNum) ? sizes[size] || sizes.medium : sizeNum;
};

var getRotationDegrees = function getRotationDegrees(rotate) {
  var rotateNum = +rotate;
  return Number.isNaN(rotateNum) ? rotations[rotate] || rotations.up : rotateNum;
};

export var getRotationTransform = function getRotationTransform(rotate) {
  if (!isValidUnit(rotate)) return;
  return "rotate(".concat(getRotationDegrees(rotate), "deg)");
};
export var getSVGRNRotationTransform = function getSVGRNRotationTransform(rotate) {
  if (!isValidUnit(rotate)) return;
  return {
    rotateZ: "".concat(getRotationDegrees(rotate), "deg")
  };
};
/** We can't use vector-effect: non-scaling-stroke; because of IE11
 * so we have to calculate the stroke width based off of size */

export var getStrokeWidth = function getStrokeWidth(size) {
  var nonScalingStroke = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!nonScalingStroke) return BASE_STROKE;
  var ratio = size / BASE_SIZE;
  return BASE_STROKE / ratio;
};